// import libs
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import api from 'Redux/middleware/';
import rootReducer from 'Redux/reducers';

const configureStore = (preloadedState) => createStore(
  rootReducer,
  preloadedState,
  applyMiddleware(thunk, api),
);

export default configureStore;
